import { useAppDispatch } from '../../store/hooks'
import React from 'react'
import { ActionTitle } from './ActionTitle'
import { ActionSuggestion } from './model'
import { openModal } from '../../store/modal/modal'
import { IntegrationIcon } from '../IntegrationIcon'

interface ActionSuggestionItemProps {
  actionSuggestion: ActionSuggestion
  onClick?: () => void
}

export const ActionSuggestionItem: React.FC<ActionSuggestionItemProps> = ({ actionSuggestion, onClick }) => {
  const dispatch = useAppDispatch()

  const handleClick = () => {
    if (!actionSuggestion.actionType || !actionSuggestion.serviceId) {
      return
    }

    dispatch(
      openModal({
        type: actionSuggestion.actionType,
        serviceId: actionSuggestion.serviceId,
        user: actionSuggestion.user,
        roomSession: actionSuggestion.roomSession,
        tasks: actionSuggestion.tasks,
        externalIntegration: actionSuggestion.externalIntegration,
      }),
    )

    if (onClick) {
      onClick()
    }
  }

  return (
    <div
      className='action-suggestion-card d-flex align-items-center gap-3 p-3'
      onClick={handleClick}
      style={{ cursor: 'pointer', border: '1px solid #adb5bd', borderRadius: '8px' }}
    >
      <IntegrationIcon serviceId={actionSuggestion.serviceId} className={'crm-icon'} />
      <ActionTitle actionSuggestion={actionSuggestion} />
    </div>
  )
}
